// 9fbef606107a605d69c0edbcd8029e5d
import { PropTypes, shape, bool, func } from 'prop-types';
import React from 'react';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import pluralize from '@tcp/core/src/utils/pluralize';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import { getViewportInfo, isClient } from '../../../../../utils';
import submitProductListingFiltersForm from '../../../../features/browse/ProductListing/container/productListingOnSubmitHandler';
import withStyles from '../../../hoc/withStyles';
import BodyCopy from '../../BodyCopy';
import Button from '../../Button';
import style, { ChipsBorder } from '../styles/FilterChips.style';
import filterChipsLabels from './FilterChips.labels';
import { getCurrentFeatureBrandAttribute } from '../../../../features/browse/SearchDetail/container/SearchDetail.util';

const FilterChips = (props) => {
  const {
    className,
    appliedFilters,
    initialValues,
    isLoadingMore,
    updateFormValue,
    getProducts,
    setPriceFlag,
    categoryPlp,
    formValues,
    handleSubmitForm,
    isFeatureBrandView,
    filterKeys,
    setPriceFilterFlagActn,
  } = props;
  const lblClear = getLabelFromCopyOrFromTranslation(
    'PLP.PLP_sort_filter.lbl_clear',
    filterChipsLabels
  );

  const priceRangeFilter = 'min_offer_price';
  const handleRemoveAllFilters = (e) => {
    e.preventDefault();
    setTimeout(() => {
      const formData = {};
      Object.keys(initialValues).forEach((key) => {
        // added this condition for shop this store expirence if there is 'from' query param in route and has shop store mode on in query param only then check this
        if (key === 'bopisStoreId' && isShopThisStoreModeOn()) {
          formData.bopisStoreId = formValues?.bopisStoreId;
        } else if (key !== 'sort') {
          updateFormValue(key, []);
        }
      });

      setPriceFlag(true);
      setPriceFilterFlagActn(true);
      submitProductListingFiltersForm(formData, false, getProducts);
      handleSubmitForm('clear');
    }, 0);
  };

  const handleRemoveFilter = (fieldName, filterId) => {
    setTimeout(() => {
      if (fieldName !== 'min_offer_price') {
        const changeParam = initialValues[fieldName]
          ? initialValues[fieldName].filter((entryId) => entryId !== filterId)
          : [];
        updateFormValue(fieldName, changeParam);
        handleSubmitForm(fieldName, changeParam);
      } else {
        setPriceFlag(true);
        setPriceFilterFlagActn(true);
        updateFormValue(fieldName, []);
        handleSubmitForm(fieldName, []);
      }
    }, 0);
  };

  const priceRangeDisplayFunc = (displayName) => {
    let name = ['', '', ''];
    name = displayName?.split(' ');
    return <span className="price-label">{`$${name[0]} ${name[1]} $${name[2]}`}</span>;
  };

  const facetClasses = (facet) => {
    if (
      facet === 'v_tcpfit_unbxd_uFilter' ||
      facet === 'v_tcpsize_uFilter' ||
      facet === 'TCPPrimaryBrandUSStore_uFilter'
    ) {
      return 'size-fit-filter';
    }
    return '';
  };

  const isDesktop = isClient() && getViewportInfo()?.isDesktop;
  const getDisplayName = (item) => {
    if (item?.facetName === priceRangeFilter) {
      return priceRangeDisplayFunc(item?.displayName);
    }
    if (item?.facetName === 'TCPColor_uFilter') {
      return pluralize(item?.displayName?.toLowerCase());
    }
    if (item?.facetName === 'TCPBazaarVoiceRating_inText_uFilter') {
      return item?.displayName?.replace('and', '&');
    }
    return item?.displayName;
  };

  const pillImg = 'search-close-icon';
  return (
    <section className={`${className} filter-chips-main `}>
      <ChipsBorder categoryPlp={categoryPlp} viewPort={isDesktop}>
        <div className="chips-container">
          <BodyCopy className="filters-label-container" fontSize={['fs16']} fontFamily="secondary">
            <div className="filters-applied-label">Filter Results</div>
            <div className="clear-all">
              <Button
                className="clear-all-button"
                aria-labelledby="filter-clear-all"
                buttonVariation="variable-width"
                onClick={(e) => {
                  if (!isLoadingMore) {
                    handleRemoveAllFilters(e);
                  }
                }}
              >
                {lblClear}
              </Button>
            </div>
          </BodyCopy>
          <div className="applied-chips">
            {appliedFilters?.map((item1) => {
              return item1
                ?.filter((filter) => {
                  if (!isFeatureBrandView) {
                    return true;
                  }
                  return filter.facetName !== getCurrentFeatureBrandAttribute(filterKeys);
                })
                ?.map((item) => {
                  return (
                    <li key={item} className={isLoadingMore ? 'disable-list-items' : ''}>
                      <BodyCopy
                        className={`applied-chip-label ${facetClasses(item?.facetName)}`}
                        fontSize={['fs16']}
                        fontFamily="secondary"
                      >
                        <span>
                          {getDisplayName(item)}
                          <Button
                            className="chip-clicks"
                            onClick={(e) => {
                              if (!isLoadingMore) {
                                e.preventDefault();
                                handleRemoveFilter(item.facetName, item?.id);
                              }
                            }}
                          >
                            <div className={`chip-image ${pillImg}`} />
                          </Button>
                        </span>
                      </BodyCopy>
                    </li>
                  );
                });
            })}
          </div>
        </div>
      </ChipsBorder>
    </section>
  );
};

FilterChips.propTypes = {
  className: PropTypes.string.isRequired,
  appliedFilters: PropTypes.shape([]).isRequired,
  initialValues: shape({}),
  isLoadingMore: bool,
  getProducts: func.isRequired,
  updateFormValue: func.isRequired,
  formValues: PropTypes.shape({}).isRequired,
  setPriceFlag: PropTypes.func,
  categoryPlp: PropTypes.bool,
  setPriceFilterFlagActn: PropTypes.func,
};
FilterChips.defaultProps = {
  initialValues: {},
  isLoadingMore: false,
  setPriceFlag: () => {},
  categoryPlp: false,
  setPriceFilterFlagActn: () => {},
};

export default withStyles(FilterChips, style);
export { FilterChips as FilterChipsVanilla };
